import { useToggleSection } from 'pages/all-tasks/hooks/use-toggle-section';
import React, { useMemo } from 'react';
import { CollapsableHierarchyList } from 'shared/components/ui/collapsable-hierarchy-list';
import { useUser } from 'shared/hooks/use-user';

import { useLifeAreaGroupingSections } from '../../hooks/use-life-area-grouping-sections';
import { EmptyLifeAreaGroupingTasksList } from '../empty-life-area-grouping-tasks-list';
import * as Styled from './life-area-grouping-tasks-list.style';

const noop = () => {};

export const LifeAreaGroupingTasksList: React.FC = () => {
  const user = useUser();
  const { treeNodes, tasks, goals, lifeAreas } = useLifeAreaGroupingSections();
  const onToggleSection = useToggleSection();

  const openedSectionIds = useMemo(
    () => [
      ...(user?.settings?.allTasks?.collapsedLifeAreas ?? []),
      ...(user?.settings?.allTasks?.collapsedGoals ?? []),
    ],
    [
      user?.settings?.allTasks?.collapsedGoals,
      user?.settings?.allTasks?.collapsedLifeAreas,
    ],
  );

  return !tasks.length ? (
    <EmptyLifeAreaGroupingTasksList />
  ) : (
    <Styled.Container>
      <CollapsableHierarchyList
        treeNodes={treeNodes}
        tasks={tasks}
        allGoals={goals}
        allLifeAreas={lifeAreas}
        openedSections={openedSectionIds}
        onCollapse={onToggleSection}
        onExpandedItemsChange={noop}
      />
    </Styled.Container>
  );
};
